import { getActiveZones } from "./index23.js";
import { isBuildingEmpty } from "./index81.js";
import { addPodium } from "./index82.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const pipeAddPodium = ([parent, { aggProps, buildingIds }]) => {
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) {
		const aggZoneProps = aggProps.zones[zone.uuid];
		if (aggZoneProps.podium) {
			const buildings = getRgObjectsOfType$1(zone, RG_TYPE.Building);
			for (const building of buildings) {
				if (buildingIds && !buildingIds.includes(building.uuid)) continue;
				if (isBuildingEmpty(building)) continue;
				addPodium(building, aggZoneProps.podium);
			}
		}
	}
	return [parent, void 0];
};
export { pipeAddPodium };

//# sourceMappingURL=index83.js.map